// extracted by mini-css-extract-plugin
export var popupForm = "PopupForm-module--popupForm--8bee2";
export var subtitle = "PopupForm-module--subtitle--e3a1a";
export var title = "PopupForm-module--title--0d8b7";